import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import "./style.css";

const MODERN_COLORS = [
  "#F1582E",
  "#003a8c",
  "#6366F1",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#3B82F6",
  "#8B5CF6",
  "#14B8A6",
  "#F43F5E",
  "#22C55E",
  "#EAB308",
];

const generateColors = (count) =>
  Array.from(
    { length: count },
    (_, i) => MODERN_COLORS[i % MODERN_COLORS.length]
  );

const parseValue = (val) => {
  if (typeof val === "string") {
    const match = val.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : 0;
  }
  return typeof val === "number" ? val : 0;
};

const CustomLegend = ({ payload }) => (
  <ul
    style={{
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 16,
    }}
  >
    {payload.map((entry, index) => (
      <li
        key={`item-${index}`}
        style={{ display: "flex", alignItems: "center", gap: 8 }}
      >
        <div
          style={{
            width: 14,
            height: 14,
            backgroundColor: entry.color,
            borderRadius: "50%",
          }}
        />
        <span style={{ fontSize: 13 }}>{entry.value}</span>
      </li>
    ))}
  </ul>
);

const PieChartComponent = ({ dataSource = [], title, height }) => {
  const colors = generateColors(dataSource.length);
  const [lebarLayar, setLebarLayar] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setLebarLayar(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const parsedData = dataSource.map((item) => ({
    label: item.label,
    value: parseValue(item.value),
  }));

  const total = parsedData.reduce((sum, item) => sum + item.value, 0);
  const isAllZero = total === 0;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      const color = payload[0].color;
      return (
        <div
          style={{
            background: "#fff",
            padding: "8px 12px",
            border: `1px solid ${color}`,
            borderRadius: 8,
            fontSize: 13,
            boxShadow: "0 0 6px rgba(0,0,0,0.15)",
          }}
        >
          <span style={{ color }}>{`${item.label} : ${item.value}`}</span>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="custom-card-container">
      <div className="card-title-responsive">{title}</div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
        }}
      >
        <div style={{ width: 300, height: height || 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              {!isAllZero && (
                <Pie
                  data={parsedData}
                  dataKey="value"
                  nameKey="label"
                  cx="50%"
                  cy="50%"
                  innerRadius="50%"
                  outerRadius="75%"
                  paddingAngle={2}
                >
                  {parsedData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={colors[index % colors.length]}
                    />
                  ))}
                </Pie>
              )}
              {isAllZero && (
                <Pie
                  data={[{ name: "Kosong", value: 1 }]}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius="50%"
                  outerRadius="75%"
                  fill="#eee"
                  isAnimationActive={false}
                />
              )}
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <CustomLegend
          payload={parsedData.map((entry, index) => ({
            value: entry.label,
            color: colors[index % colors.length],
          }))}
        />
      </div>
    </div>
  );
};

export default PieChartComponent;
